import type { SVGProps } from 'react'

export function Plus(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Plus icon</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 7C1.44772 7 1 7.44772 1 8C1 8.55228 1.44772 9 2 9L7 9V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V9L14 9C14.5523 9 15 8.55228 15 8C15 7.44771 14.5523 7 14 7L9 7V2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V7L2 7Z'
        fill='currentColor'
      />
    </svg>
  )
}
